import { useAttributesByType } from '../../attributes/use-attributes-by-type';
import { useMemo } from 'react';
import { toAttributeOption } from '../../attributes/to-attribute-option';
import { QueueAttributeFilter } from '@mark43/cad-api';

export const useHospitalQueueAttributeFilter = (
    attributeType: 'HOSPITAL_STATUS' | 'HOSPITAL_CAPABILITY',
    attributeFilters: QueueAttributeFilter[]
) => {
    const { attributes } = useAttributesByType({
        attributeType,
        params: {
            include_is_none: true,
        },
    });

    const options = useMemo(() => attributes.map((attr) => toAttributeOption(attr)), [attributes]);

    const selectedFilterValues = useMemo(
        () => attributeFilters.map((attributeFilter) => attributeFilter.attributeId),
        [attributeFilters]
    );

    return { options, selectedFilterValues };
};
